<template>
  <div class="text-center d-flex align-center justify-center flex-column h-100">
    <h1>404</h1>
    <p>Страница не найдена</p>
    <router-link
     to="/dashboard" 
     class="text-caption mt-5 text-primary text-decoration-none">
      <v-icon>mdi-arrow-left</v-icon>
      Вернуться на главную
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>